import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import './QRCodePage.css';
import { QRCodeCanvas } from "qrcode.react";
import qrImage from "../../assets/images/mfa/mfa-image.svg";
import arrorIcon from "../../assets/images/mfa/ic-arrow-back.svg";
import timerIcon from "../../assets/images/mfa/timer.svg";

const QRCodePage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { qrData } = location.state || {};
    const [timeLeft, setTimeLeft] = useState(300);

    useEffect(() => {
        if (!qrData) return;

        const timer = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timer);
    }, [qrData]);


    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };

    if (!qrData) {
        return <p>No QR data available</p>;
    }

    const handleQRCode = () => {
        navigate("/ui/secret-key-page", { state: { qrData } });
    }

    return (
        <div className="qr-page">
            <button className="back-link" onClick={() => navigate(-1)}>
                <img src={arrorIcon} alt="Back Arrow" className="back-icon" />
                <span className="back-text">Back</span>
            </button>

            <div className="qr-container">
                <div className="logo-section">
                    <img src={qrImage} alt="ready-link-marketplace" className="logo" />
                </div>
                <div className="heading-section">
                    <span className="qr-heading">
                        Scan the QR Code to configure secret key
                    </span>
                    <span className="qr-subHeading">Use this QR code to configure the secret key in any of your authenticator apps like Google authenticator, Authy or any other..
                    </span>
                </div>

                <div className="qr-box">
                    <div className="qr-info">
                        <p className="qr-info-text">QR code is about to expire in</p>
                        <div className="qr-timer">
                            <img src={timerIcon} alt="timer" className="timer-icon" />
                            <span className="timer-value">{formatTime(timeLeft)}</span>
                        </div>
                    </div>
                    <div className="qr-code">
                        <QRCodeCanvas value={qrData.secretCode} size={200} />
                    </div>
                </div>

                <button className="generate-btn" onClick={handleQRCode}>
                    Next
                </button>
            </div>
            <div className="footer-container">
                <p className="footer-text">
                    Copyright © 2020 HARMAN International. All Rights Reserved.
                </p>

                <p className="footer-text">
                    Need help? Please contact us at{" "}
                    <a href="mailto:IgniteDevSupport@Harman.com" className="footer-link">
                        IgniteDevSupport@Harman.com
                    </a>
                </p>
                <p href="/developer-agreementDeveloper Agreement">Developer Agreement
                </p>
            </div>
        </div>
    );
}

export default QRCodePage;
